export default __webpack_public_path__ + "static/media/uncommon-icon.fe4095a5.png";